
import AutocallButtonOff from "@/components/autocall/AutocallButtonOff.vue"
import BoardMarquee from "@/components/BoardMarquee.vue"
import ButtonIcon from "@/components/ButtonIcon.vue"
import ButtonBig from "@/components/ButtonBig.vue"
import HeaderLogo from "@/components/HeaderLogo.vue"

import { defineComponent, computed } from "vue"
import { useStore } from "vuex"
import { useRoute } from "vue-router"

export default defineComponent({
  components: {
    BoardMarquee,
    AutocallButtonOff,
    ButtonIcon,
    ButtonBig,
    HeaderLogo,
  },
  setup() {
    const { state, commit } = useStore()
    const { query } = useRoute()
    const { lastcall, carnumber } = query
    const isCarChecked = computed(() => state.autocall.isCarChecked)

    commit("autocall/SET_CARNUMBER", carnumber)

    return {
      isCarChecked,
      lastcall,
    }
  },
})
